import { actionTypes } from './actions';

const initialState = {
  request: null,
  response: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.HTTP_REQUEST: {
      const { request } = action.payload;
      return { ...initialState, request };
    }
    case actionTypes.HTTP_SUCCESS: {
      const { response } = action.payload;
      return { ...state, response };
    }
    default: {
      return state;
    }
  }
}
